<template>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center" v-if="isServiceDetailsRoute">
		<div class="container">
			<div class="row">
				<div class="col-md-12 col-12">
					<h2 class="breadcrumb-title mb-2">{{ title }}</h2>
					<nav aria-label="breadcrumb">
						<ol class="breadcrumb justify-content-center mb-0">
							<li class="breadcrumb-item"><router-link to="/home/"><i class="ti ti-home-2"></i></router-link></li>
							<li class="breadcrumb-item">{{ text }}</li>
							<li class="breadcrumb-item active" aria-current="page">{{ text1 }}</li>
						</ol>
					</nav>
				</div>
			</div>
			<div class="breadcrumb-bg">
				<img src="@/assets/img/bg/breadcrumb-bg-01.png" class="breadcrumb-bg-1" alt="Img">
				<img src="@/assets/img/bg/breadcrumb-bg-02.png" class="breadcrumb-bg-2" alt="Img">
			</div>
		</div>
	</div>
  
  <div class="breadcrumb-bar text-center" v-else>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">{{ title }}</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home/"><i class="ti ti-home-2"></i></router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">{{ text }}</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="breadcrumb-bg">
        <img
          src="@/assets/img/bg/breadcrumb-bg-01.png"
          class="breadcrumb-bg-1"
          alt="Img"
        />
        <img
          src="@/assets/img/bg/breadcrumb-bg-02.png"
          class="breadcrumb-bg-2"
          alt="Img"
        />
      </div>
    </div>
  </div>
  
  <!-- /Breadcrumb -->
</template>
<script>
export default {
  computed: {
		isServiceDetailsRoute() {
			return  this.$route.path === "/details/service-details" ||
			this.$route.path === "/details/service-details2";
		},
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
  },
};
</script>
